var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD430(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 17C30 20.2381 27.8796 22.9627 25 23.7623V21.6467C26.7314 20.9218 28 19.1518 28 17C28 14.1696 25.8053 12 23.2493 12C22.5272 12 21.8339 12.1732 21.2108 12.4855C21.1791 11.9037 21.0937 11.3367 20.9599 10.7899L20.9569 10.7911C20.0091 6.85004 16.5839 4 12.6083 4C7.92179 4 4 7.96046 4 13C4 16.2291 5.61019 19.0152 8 20.6003V22.9107C4.44938 21.1323 2 17.3628 2 13C2 6.92487 6.74949 2 12.6083 2C17.469 2 21.5661 5.38976 22.821 10.0139C22.9626 10.0047 23.1054 10 23.2493 10C26.9776 10 30 13.134 30 17ZM10.001 22.4091C10.0009 21.9308 10.1533 21.4108 10.3609 20.9244C10.8044 19.8856 11.5 19 11.5 19C11.5 19 12.1643 19.9175 12.609 20.9252C12.8327 21.4321 13.0009 21.9619 13.001 22.4091C13.0013 23.2877 12.33 24 11.5015 24C10.6731 24 10.0013 23.2877 10.001 22.4091ZM15.3609 20.9244C15.1533 21.4108 15.0009 21.9308 15.001 22.4091C15.0013 23.2877 15.6731 24 16.5015 24C17.33 24 18.0013 23.2877 18.001 22.4091C18.0009 21.9619 17.8327 21.4321 17.609 20.9252C17.1643 19.9175 16.5 19 16.5 19C16.5 19 15.8044 19.8856 15.3609 20.9244ZM12.8756 27.4091C12.8754 26.9308 13.0278 26.4108 13.2354 25.9244C13.6789 24.8856 14.3745 24 14.3745 24C14.3745 24 15.0388 24.9175 15.4835 25.9252C15.7072 26.4321 15.8754 26.9619 15.8756 27.4091C15.8758 28.2877 15.2045 29 14.376 29C13.5476 29 12.8758 28.2877 12.8756 27.4091ZM20.3609 20.9244C20.1533 21.4108 20.0009 21.9308 20.001 22.4091C20.0013 23.2877 20.6731 24 21.5015 24C22.33 24 23.0013 23.2877 23.001 22.4091C23.0009 21.9619 22.8327 21.4321 22.609 20.9252C22.1643 19.9175 21.5 19 21.5 19C21.5 19 20.8044 19.8856 20.3609 20.9244ZM17.8905 27.4091C17.8903 26.9308 18.0427 26.4108 18.2503 25.9244C18.6938 24.8856 19.3894 24 19.3894 24C19.3894 24 20.0537 24.9175 20.4984 25.9252C20.7221 26.4321 20.8903 26.9619 20.8904 27.4091C20.8907 28.2877 20.2194 29 19.3909 29C18.5625 29 17.8907 28.2877 17.8905 27.4091Z",
    fill: "url(#paint0_linear_9_3214)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_3214",
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD430);
export default __webpack_public_path__ + "static/media/d430.670fe605158515adf21a2580ddb628b8.svg";
export { ForwardRef as ReactComponent };